import ConfirmAction from "./ConfirmAction";

const Popup = {
  ConfirmAction
}

export default Popup;